import axios from 'axios'
import { useQuery } from '@tanstack/react-query'

const currentVersion = process.env.APP_VERSION

async function fetchAppVersion() {
  const res = await axios.get(`/version.json?ts=${Date.now()}`)
  return res.data
}

export function useUpdateNotifierLogic() {
  const { data } = useQuery({
    queryKey: ['appVersion'],
    queryFn: fetchAppVersion,
    refetchInterval: 60_000,
    staleTime: 0,
    retry: false,
  })

  const updateAvailable = !!data && data.version?.toString() !== currentVersion

  return { updateAvailable }
}
